import strings from "components/release/useful-links/UsefulLinks.strings.json";
import { generateLinksBase } from "components/release/useful-links/helpers/generateLinksBase";
import {
  LinkOptions,
  linksMap,
} from "components/release/useful-links/helpers/linksMap";
import type { SemVer } from "util/version";

// generates all the links for Play Console Native Crashes for minor build version
export const generatePlayConsoleNativeCrashLinks = (
  versions: SemVer[],
): JSX.Element[] =>
  generateLinksBase(
    versions,
    strings.PlayConsoleNativeCrashes,
    linksMap[LinkOptions.PLAY_CONSOLE_NATIVE_CRASH],
  );
